module.exports = __webpack_public_path__ + "img/scene-logistics.6fcf115f.jpg";